import styled from "styled-components";

export const ScaleContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    list-style: none;
    display: ${(props) => (props.show ? "flex" : "none")};
`;

export const ScaleLine = styled.div`
    border-top: 0.09rem solid #a3a6ab;
    width: 0.375rem;
    &:first-child {
        border-top: none;
    }
    &:last-child {
        border-top: none;
    }
`;
